export default "__VITE_ASSET__CRg8xzNK__"